module.exports = __webpack_public_path__ + "img/details_recr.43d3654b.png";